// service for send out admin invite email
export const getReviews = async (
  apiInstance,
  minimumStars,
  minimumChars,
  pictureRequired,
) => {
  try {
    const response = await apiInstance.get(
      `/public/reviews?minimumStars=${minimumStars}&minimumChars=${minimumChars}&pictureRequired=${pictureRequired}`,
    );
    return response.data;
  } catch (err) {
    console.error("An error occurred:", err);
    return null; // Return null instead of throwing to avoid breaking the component
  }
};

export const getCouponPrice = async (apiInstance, code) => {
  try {
    const response = await apiInstance.get(`/public/coupon-code?code=${code}`);
    return response.data;
  } catch (err) {
    console.error("An error occurred:", err);
    return null;
  }
};
